import { useEffect, useState } from "react";
import { Icon } from "@vds/icons";
import { MAX_BULK_RESOLVE_LIMIT, EVENTS_INFO_CONSTANTS, RESOLVE_STATUS } from "../../../global/constants/constants";
import "./SelectAllEventsBanner.scss";

// VDS color constant (matches SCSS variable)
const VDS_ERROR_COLOR = "#D43315";

const SelectAllEventsBanner = ({
  selectedIncidentList,
  setActionType,
  setShowResolveEvents,
  resolveStatus,
  unresolvedCount = 0,
  isUnresolvedCountLoading = false,
}) => {
  const [showInlineError, setShowInlineError] = useState(false);

  // Clear inline error when count drops below limit or selections cleared
  useEffect(() => {
    if (showInlineError) {
      const shouldClearError =
        // If user refined filters and count is now acceptable
        unresolvedCount <= MAX_BULK_RESOLVE_LIMIT ||
        // If selections were cleared (banner will disappear)
        selectedIncidentList.length === 0;

      if (shouldClearError) {
        setShowInlineError(false);
      }
    }
  }, [unresolvedCount, selectedIncidentList.length, showInlineError]);

  // Clear inline error when component unmounts
  useEffect(() => {
    return () => {
      if (showInlineError) {
        setShowInlineError(false);
      }
    };
  }, [showInlineError]);

  const isResolutionInProgress = resolveStatus?.status === RESOLVE_STATUS.IN_PROGRESS;
  const isOverLimit = unresolvedCount > MAX_BULK_RESOLVE_LIMIT;
  const isDisabled = isResolutionInProgress; // Only disable during resolution, not when over limit

  // Show bulk resolve link when there are more than 10 unresolved events matching current filters
  const shouldShowBulkResolveLink = unresolvedCount > 10 && unresolvedCount > selectedIncidentList.length;

  return (
    <div className="hover-box">
      <strong>{selectedIncidentList.length}&nbsp;</strong> event
      {selectedIncidentList.length <= 1 ? "" : "s"} on this page
      {selectedIncidentList.length <= 1 ? " is" : " are"} selected.
      {isUnresolvedCountLoading && (
        <>{" "}<span className="banner-loading">Loading...</span></>
      )}
      {!isUnresolvedCountLoading && shouldShowBulkResolveLink && (
        <>
          {" "}
          <span
            className={`banner-link ${isDisabled ? "banner-link--disabled" : ""}`}
            onClick={() => {
              // Block if resolution is in progress
              if (isResolutionInProgress) {
                return;
              }

              // Show inline error if over limit
              if (isOverLimit) {
                setShowInlineError(true);
                return;
              }

              // Proceed with bulk resolve
              setActionType("bulkfilter");
              setShowResolveEvents({ isOpen: true });
            }}
          >
            <strong>&nbsp;Resolve all {unresolvedCount} {unresolvedCount === 1 ? "event" : "events"} &nbsp;</strong>
          </span>{" "}
          that match the filters selected.
        </>
      )}
      {isResolutionInProgress && (
        <div className="banner-warning">
          <Icon name="warning" size="small" color={VDS_ERROR_COLOR} />
          <strong className="banner-warning__text">{EVENTS_INFO_CONSTANTS.RESOLUTION_IN_PROGRESS_INLINE}</strong>
        </div>
      )}
      {showInlineError && isOverLimit && !isResolutionInProgress && (
        <div className="banner-warning">
          <Icon name="warning" size="small" color={VDS_ERROR_COLOR} />
          <strong className="banner-warning__text">{EVENTS_INFO_CONSTANTS.BULK_RESOLVE_LIMIT_ERROR_INLINE(MAX_BULK_RESOLVE_LIMIT, unresolvedCount)}</strong>
        </div>
      )}
    </div>
  );
};

export default SelectAllEventsBanner;
